// extracted by mini-css-extract-plugin
export default {"top":"SideTop_top__ne-Sd","left":"SideTop_left__WZoZW","right":"SideTop_right__LbMZD","userName":"SideTop_userName__ui90a"};